import React from 'react';
import { Grid, TextField, Box, Divider } from '@mui/material';
import { SectionHeader } from '../AddPatientStyles';

const StepLifePath = ({ formData, handleChange }) => {
  return (
    <Box>
      <SectionHeader title="Cadre de l'entretien" description="Contexte de la rencontre avec le patient" />
      <Grid container spacing={2.5}>
        <Grid item xs={12} sm={4}><TextField fullWidth label="Date de l'entretien" name="date_entretien" type="date" InputLabelProps={{ shrink: true }} value={formData.date_entretien} onChange={handleChange} /></Grid>
        <Grid item xs={12} sm={4}><TextField fullWidth label="Pratique ou coordination" name="pratique_ou_coordination" value={formData.pratique_ou_coordination} onChange={handleChange} /></Grid>
        <Grid item xs={12} sm={4}><TextField fullWidth label="Coordinatrices" name="coordinatrices" value={formData.coordinatrices} onChange={handleChange} /></Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />
      <SectionHeader title="Parcours de vie" description="Récit libre du patient sur les grandes étapes de sa vie" />
      <Grid container spacing={2.5}>
        <Grid item xs={12} sm={6}><TextField fullWidth multiline minRows={4} label="Enfance, famille, naissance" name="enfance_famille_naissance" value={formData.enfance_famille_naissance} onChange={handleChange} /></Grid>
        <Grid item xs={12} sm={6}><TextField fullWidth multiline minRows={4} label="Vie de couple & famille" name="vie_couple_famille" value={formData.vie_couple_famille} onChange={handleChange} /></Grid>
        <Grid item xs={12} sm={6}><TextField fullWidth multiline minRows={4} label="Vie professionnelle" name="vie_professionnelle" value={formData.vie_professionnelle} onChange={handleChange} /></Grid>
        <Grid item xs={12} sm={6}><TextField fullWidth multiline minRows={4} label="Vie aujourd'hui" name="vie_aujourd_hui" value={formData.vie_aujourd_hui} onChange={handleChange} /></Grid>
        <Grid item xs={12}><TextField fullWidth multiline minRows={4} label="Résumé du chemin de vie" name="resume_chemin_de_vie" value={formData.resume_chemin_de_vie} onChange={handleChange} /></Grid>
      </Grid>
    </Box>
  );
};

export default StepLifePath;